export default __webpack_public_path__ + "static/media/avatar_67.a911be0d.png";